import { Box, Popover, PopoverTrigger, Spinner } from '@chakra-ui/react'
import { lazy, Suspense, useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { MLContext } from '../../../../providers'
import { MediaLibraryActions } from '../../../../providers/MLProvider'

const NewThreadPanel = lazy(() => import('./NewThreadPanel'))

interface Props {
  position: { x: number; y: number } | null
  setThreadPanelPosition: React.Dispatch<
    React.SetStateAction<{
      x: number
      y: number
    } | null>
  >
}

const Loader = ({
  position,
  setThreadPanelPosition,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const parentRef = useRef<HTMLDivElement | null>(null)
  const [{ threadListUiLoaded, showNewThreadPanel }, dispatch] =
    useContext(MLContext)

  useEffect(
    () => () => {
      // cleanup hook
      if (!threadListUiLoaded) {
        dispatch({ type: MediaLibraryActions.THREAD_LIST_UI_LOADED })
      }
    },
    [],
  )

  return position ? (
    <Popover
      isLazy
      isOpen={showNewThreadPanel}
      placement={position.y > 75 && position.x < 50 ? 'top-start' : 'auto'}
    >
      <PopoverTrigger>
        <Box
          position="absolute"
          top={`${position.y}%`}
          left={`${position.x}%`}
          transform="translate(-50%, -50%)"
          onClick={() => {
            void setThreadPanelPosition(null)
            dispatch({
              type: MediaLibraryActions.SHOW_NEW_THREAD_PANEL,
              payload: false,
            })
          }}
        >
          <Spinner />
        </Box>
      </PopoverTrigger>
    </Popover>
  ) : showNewThreadPanel ? (
    <Box
      ref={parentRef}
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      border="1px solid #E2E8F0"
      borderRadius="9px"
      zIndex={2000}
    >
      <Spinner />
    </Box>
  ) : (
    <></>
  )
}

const LazyNewThreadPanel = props => (
  <Suspense fallback={<Loader {...props} />}>
    <NewThreadPanel {...props} />
  </Suspense>
)

export default LazyNewThreadPanel
